import { makeStyles } from '@material-ui/styles';
import { colors } from '../../../style/colors';
import { ITheme } from '../../../style/theme';

export const useStyles = makeStyles((theme: ITheme) => ({
  skeletonCard: {
    width: 350,
    height: 341,
    boxShadow: '0 6px 12px rgba(27, 27, 28, 0.15)',
    borderRadius: 16,
    backgroundColor: colors.white,
    [theme.breakpoints.down('xs')]: {
      width: 335,
    },
    [theme.breakpoints.down(380)]: {
      width: '100%',
      minWidth: 256,
    },
  },
  rounded: {
    borderRadius: 100,
  },
  roundedTop: {
    borderRadius: '14px 14px 0 0',
  },
  content: {
    padding: 24,
  },
  header: {
    display: 'grid',
    gridGap: 8,
    overflow: 'hidden',
  },
  avatar: {
    display: 'flex',
    margin: '25px 0 40px 0',
    gap: 8,
  },
  avatarText: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  footer: {
    display: 'flex',
    justifyContent: 'center',
  },
}));
